module.exports = __webpack_public_path__ + "md.d09118be.svg";